export default __webpack_public_path__ + "static/media/643.676a5cc8.jpg";